import { LoadingOverlay } from "@/components/ui/overlays/LoadingOverlay";
import { ErrorBanner } from "@/components/ui/overlays/ErrorBanner";
import { useAnimations } from "@/hooks/useAnimations";
import { useFilterIsShaken } from "@/hooks/useFilter";
import { PostShake } from "./Postshake";
import { PreShake } from "./Preshake";
import { Shaking } from "./Shaking";
import { Transitions } from "@/context/Transitions";
import { useUiStore } from "@/stores/useUiStore";
import { useEffect } from "react";

export type UiProps = {
  ani: ReturnType<typeof useAnimations>;
};

export function Ui() {
  const ani = useAnimations();
  const { phase, setPhase } = useUiStore();
  const [isShaken] = useFilterIsShaken();

  // Sync phase with URL on mount — if arriving via shared link the blend is already shaken
  useEffect(() => {
    if (phase === 'shaking') return;
    setPhase(isShaken ? 'postshake' : 'preshake');
  }, [isShaken]); // eslint-disable-line react-hooks/exhaustive-deps
 
  return (
    <Transitions>
      
      {/* Overlays */}
      <LoadingOverlay />
      <ErrorBanner />

      {/* Views */}
      {/* {phase === 'loading' &&  <LoadingOverlay /> (transition) null}
      {phase === 'error' && null (transition/toast/destination)}
      {phase === 'fatalError' && null} (destination) */}
      {phase === 'preshake'  && <PreShake  ani={ani} />}
      {phase === 'shaking'   && <Shaking   ani={ani} />}
      {phase === 'postshake' && <PostShake ani={ani} />}
      {phase === 'reset' && null}

    </Transitions>
  );
}
